const urlRelatoriosLog = "/v1/RelatoriosDeLog";

const service = {
  methods: {
    $obterRelatorioLogPerfil(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogPerfil`, params);
    },
    $obterRelatorioLogCSVPerfil(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDePerfilCsv`, params);
    },
    $obterRelatorioLogPDFPerfil(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioDeLogDePerfilPDF`, this.$getParamsObject(params));
    },
  }
};

export default service;